import React, {FC, useState} from 'react';
import TriangleTwo from '../../images/triangle_two.png';
import TriangleThree from '../../images/triangle_three.png';
import Button from '../../components/button';
import homePageIllustration from '../../images/hexomatic/Hexomatic-robot-graphic.svg';
// import { Input } from "../../components/form/input/index";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faSpinner } from "@fortawesome/free-solid-svg-icons";
// import capterra from "../../images/ratings/capterra.svg";
// import getApp from "../../images/ratings/getApp.svg";
// import productHunt from "../../images/ratings/product-hunt.svg";
// import g2 from "../../images/ratings/g2.svg";
import {navigate} from 'gatsby-link';
import SubscriptionModal from '../../components/subscriptionModal';
import MiddleSection from './middle-section';
import shuttle from '../../images/svgIcons/shuttle.svg';

import {getShowModalonClick, getUserExists, setShowModalonClick} from '../../helpers';

import './styles.scss';
import UserWrap from '../userWrap';

const HomePageUpperSection: FC<{user?: boolean}> = ({user}) => {
  const [show, setShow] = useState(false);

  return (
    <section className={`seo_home_area`} id="seo_home_area">
      <div className="home_bubble">
        <div className="bubble b_one" />
        <div className="bubble b_two" />
        <div className="bubble b_four" />
        <div className="bubble b_five" />
        <div className="bubble b_six" />
        <div className="triangle b_eight">
          <img src={TriangleTwo} alt="icon" />
        </div>
        <div className="triangle b_nine">
          <img src={TriangleThree} alt="icon" />
        </div>
      </div>
      <div className="container_home">
        {/* <div className="row_home" style={{ justifyContent: "center" }}>
          <h1 className="col-12 f_size_30 f_700 t_color3 l_height40 mt_20 mb-30 text-center">
            Hexomatic. The no-code, point and click work automation platform.
          </h1> */}
        {/* {
            //@ts-ignore
            <iframe
              src="https://player.vimeo.com/video/536300687?title=0&byline=0&portrait=0"
              width="736"
              height="414"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            ></iframe>
          } */}
        {/* </div> */}
        <div className="row_home">
          <h1
            className="f_size_32 f_700 t_color3 l_height40 mb_20 text-center w_100"
            style={{maxWidth: '700px', margin: 'auto'}}
          >
            Hexomatic. The no-code, data extraction and work automation platform.
          </h1>
          <div className="col-lg-6 d-flex align-center" style={{verticalAlign: 'middle'}}>
            <div className="prototype_content_home">
              <div>
                <p>
                  Create your own bots in minutes to extract data from any website and leverage 70+ ready made
                  automations to scale time consuming tasks on autopilot.
                </p>
                <p>Hexomatic works 24/7 from the cloud, no complex software or coding required.</p>
              </div>
              <UserWrap
                withoutUser={() => (
                  <Button primary className="ltd_btn home-page-btn" onClick={() => navigate('/#registration')}>
                    Get started free
                  </Button>
                )}
                withLoading={() => (
                  <Button
                    primary
                    className="ltd_btn home-page-btn"
                    onClick={() => (window.location.href = 'https://dash.hexomatic.com')}
                  >
                    Get started free
                  </Button>
                )}
                withUser={user => (
                  <Button
                    primary
                    className="ltd_btn home-page-btn"
                    onClick={() => (window.location.href = 'https://dash.hexomatic.com')}
                  >
                    Get started free
                  </Button>
                )}
              />
              {/* <Countdown /> */}
              <div className="d-none d-lg-block growth-hacking-link text-center">
                <span
                  className="clickable-text"
                  onClick={() => {
                    if (user || getUserExists() === 'true' || getShowModalonClick() === 'false') {
                      window.open('https://hexomatic.com/the_growth_hacking_playbook.pdf', '_blank');
                    } else {
                      setShowModalonClick('true');
                      setShow(true);
                    }
                  }}
                >
                  Get our growth hacking playbook
                  <img src={shuttle} alt="shuttle" />
                </span>
              </div>
            </div>
          </div>
          <div
            className="col-lg-6 text-center img m-auto"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            {/* {
              //@ts-ignore
              <iframe
                src="https://player.vimeo.com/video/568438640?badge=0&autopause=0&player_id=0&app_id=58479"
                width="600"
                height="338"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                style={{ maxWidth: "100%", margin: "auto" }}
              ></iframe>
            } */}
            {/* {
              <iframe width="560" height="315" style={{ maxWidth: "100%", margin: "auto" }} src="https://www.youtube.com/embed/_2DF0C1yegY" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            } */}
            {/* <img
              src={homePageIllustration}
              alt="Hexomatic. The no-code, point and click work automation platform."
              style={{ maxWidth: "100%", marginRight: "-20px" }}
            /> */}
            {/*<Input
              name="email"
              placeholder="example@gmail.com"
              value={email}
              required
              onChange={(e: any) => setEmail(e.target.value)}
              type="email"
              max={190}
              className="mt_40"
            />
            <p
              style={{
                color: errorMessage ? "red" : "green",
                textAlign: "center",
                margin: "15px 0 0 0",
              }}
            >
              {errorMessage || successMessage}
            </p>*/}
            <div>
              <img
                src={homePageIllustration}
                alt="Hexomatic. The no-code, data extraction"
                className="home-page-image"
              />
            </div>
            <div className="d-lg-none growth-hacking-link text-center">
              <span
                className="clickable-text"
                onClick={() => {
                  if (user || getUserExists() === 'true' || getShowModalonClick() === 'false') {
                    window.open('https://hexomatic.com/the_growth_hacking_playbook.pdf', '_blank');
                  } else {
                    setShowModalonClick('true');
                    setShow(true);
                  }
                }}
              >
                Get our growth hacking playbook
                <img src={shuttle} alt="shuttle" />
              </span>
            </div>
          </div>

          {show && <SubscriptionModal handleSetShow={(arg: boolean) => setShow(arg)} isModalOpen={show} />}
        </div>
        <MiddleSection />
      </div>
    </section>
  );
};

export default HomePageUpperSection;
